import { __spreadArray } from "tslib";
import { BaseAPI } from './base';
import globalAxios from 'axios';
function isAxiosConfigObject(arg) {
    return arg && typeof arg === 'object' && 'axios' in arg;
}
export function APIFactory(basePathOrActions, actionsOrConfig, config) {
    var basePath = undefined;
    var actions;
    var apiConfig = { axios: globalAxios };
    if (typeof basePathOrActions === 'string') {
        basePath = basePathOrActions;
        actions = actionsOrConfig;
        if (config) {
            apiConfig = config;
        }
    }
    else {
        actions = basePathOrActions;
        if (actionsOrConfig && isAxiosConfigObject(actionsOrConfig)) {
            apiConfig = actionsOrConfig;
        }
    }
    var api = new BaseAPI(basePath, apiConfig);
    var _loop_1 = function (key) {
        var _b;
        var method = actions[key];
        Object.assign(api, (_b = {},
            _b[key] = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return method.apply(void 0, __spreadArray([api.sendRequest.bind(api)], args, false));
            },
            _b));
    };
    for (var _i = 0, _a = Object.keys(actions); _i < _a.length; _i++) {
        var key = _a[_i];
        _loop_1(key);
    }
    return api;
}
//# sourceMappingURL=utils.js.map